import React from "react";
import { Lightbulb, ListChecks, Leaf, Activity } from "lucide-react";

const Chips = ({ items, testid }) => (
  <div className="flex flex-wrap gap-2" data-testid={testid}>
    {items.map((it, i) => (
      <span key={i} className="text-xs px-3 py-1 rounded-full bg-[#F9F6F0] border border-[#D1C7B8] text-[#2D322B]">{it}</span>
    ))}
  </div>
);

const Block = ({ icon, title, children }) => (
  <div>
    <p className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[#C05C42] mb-2">{icon}{title}</p>
    {children}
  </div>
);

export const ProtocolCard = ({ protocol, footer, compact = false, testid = "protocol-card" }) => {
  const { title, takeaways = [], action_steps = [], suggestions = [], markers = [] } = protocol || {};
  const empty = !takeaways.length && !action_steps.length && !suggestions.length && !markers.length;
  return (
    <div className="rounded-2xl border border-[#D1C7B8] bg-gradient-to-br from-[#F1ECE4] to-[#EFE7DA] p-5 space-y-4" data-testid={testid}>
      <div className="flex items-center gap-2">
        <Leaf className="w-4 h-4 text-[#3F6B45]" />
        <p className="font-serif text-lg text-[#2D322B] leading-tight">{title || "Your protocol"}</p>
      </div>

      {empty && <p className="text-sm text-[#5C6359]">No structured points were found.</p>}

      {takeaways.length > 0 && (
        <Block icon={<Lightbulb className="w-3.5 h-3.5" />} title="Key takeaways">
          <ul className="space-y-1.5">
            {takeaways.map((t, i) => (
              <li key={i} className="text-sm text-[#2D322B] flex gap-2"><span className="text-[#D49A44]">•</span><span>{t}</span></li>
            ))}
          </ul>
        </Block>
      )}

      {action_steps.length > 0 && (
        <Block icon={<ListChecks className="w-3.5 h-3.5" />} title="Action steps">
          <ul className="space-y-1.5">
            {action_steps.map((t, i) => (
              <li key={i} className="text-sm text-[#2D322B] flex gap-2">
                <span className="mt-0.5 w-4 h-4 rounded border border-[#3F6B45] shrink-0 flex items-center justify-center text-[#3F6B45] text-[10px]">✓</span>
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </Block>
      )}

      {!compact && suggestions.length > 0 && (
        <Block icon={<Leaf className="w-3.5 h-3.5" />} title="Plants & protocols">
          <Chips items={suggestions} testid={`${testid}-suggestions`} />
        </Block>
      )}

      {!compact && markers.length > 0 && (
        <Block icon={<Activity className="w-3.5 h-3.5" />} title="Biomarkers to track">
          <Chips items={markers} testid={`${testid}-markers`} />
        </Block>
      )}

      {footer}
    </div>
  );
};

export default ProtocolCard;
